<template>
    <div>
        <app-text
            label="Name"
            :data-source="'deha.user.misc.sectors.' + listitemId + '.data.name'"
            :data-preset="'Listpresets.sectors'"
            :data-default="{ type: 'raw', value: 'Ihre Leistung' }"
            required
            :maxlength="255"
        ></app-text>

        <app-wysiwyg
            label="Überschrift"
            :data-source="'deha.user.misc.sectors.' + listitemId + '.data.title'"
            :data-default="{
                type: getProp('deha.user.misc.sectors.' + listitemId + '.preset_id')
                    ? 'textpicker'
                    : 'raw',
                value: getProp('deha.user.misc.sectors.' + listitemId + '.preset_id')
                    ? false
                    : 'Schreiben Sie einen Titel, der Ihre Leistung am besten beschreibt'
            }"
            :textpicker-namespace="
                getProp('deha.user.misc.sectors.' + listitemId + '.preset_id')
                    ? 'sectors/' +
                      getProp('deha.user.misc.sectors.' + listitemId + '.preset_id') +
                      '/title'
                    : ''
            "
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Unterüberschrift"
            :data-source="'deha.user.misc.sectors.' + listitemId + '.data.subtitle'"
            :data-default="{
                type: getProp('deha.user.misc.sectors.' + listitemId + '.preset_id')
                    ? 'textpicker'
                    : 'raw',
                value: getProp('deha.user.misc.sectors.' + listitemId + '.preset_id')
                    ? false
                    : 'Schreiben Sie einen Untertitel, der Ihre Leistungsbeschreibung ergänzt'
            }"
            :textpicker-namespace="
                getProp('deha.user.misc.sectors.' + listitemId + '.preset_id')
                    ? 'sectors/' +
                      getProp('deha.user.misc.sectors.' + listitemId + '.preset_id') +
                      '/subtitle'
                    : ''
            "
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Text"
            :data-source="'deha.user.misc.sectors.' + listitemId + '.data.text'"
            :data-default="{
                type: getProp('deha.user.misc.sectors.' + listitemId + '.preset_id')
                    ? 'textpicker'
                    : 'raw',
                value: getProp('deha.user.misc.sectors.' + listitemId + '.preset_id')
                    ? false
                    : 'Fassen Sie zusammen, wie Ihre Leistung aufgebaut ist und was Sie Ihrem Kunden anbieten.'
            }"
            :textpicker-namespace="
                getProp('deha.user.misc.sectors.' + listitemId + '.preset_id')
                    ? 'sectors/' +
                      getProp('deha.user.misc.sectors.' + listitemId + '.preset_id') +
                      '/text'
                    : ''
            "
            :maxlength="1024"
        ></app-wysiwyg>

        <app-filepicker
            label="Bild"
            :data-source="'deha.user.misc.sectors.' + listitemId + '.data.image'"
            accept=".jpg,.png,.gif"
        ></app-filepicker>

        <!--
        <label>Icon</label>
        <img
            width="100"
            v-bind:src="
                generateMediaUrl({
                    id: getProp('deha.user.misc.sectors.' + listitemId + '.data.icon.id'),
                    i: 1,
                    v: getActiveIconstyle,
                    w: 100
                })
            "
            alt=""
        />
        -->

        <app-link
            label="Button 1"
            :data-source="'deha.user.misc.sectors.' + listitemId + '.data.link'"
        ></app-link>

        <app-link
            label="Button 2"
            :data-source="'deha.user.misc.sectors.' + listitemId + '.data.link2'"
        ></app-link>

        <app-link
            label="Button 3"
            :data-source="'deha.user.misc.sectors.' + listitemId + '.data.link3'"
        ></app-link>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import Wysiwyg from '@/components/fields/simple/Wysiwyg.vue';
import Filepicker from '@/components/fields/complex/Filepicker.vue';
import Link from '@/components/assorted/Link.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'generateMediaUrl', 'getActiveIconstyle']),
        getMonths() {
            return {
                1: 'Januar',
                2: 'Februar',
                3: 'März',
                4: 'April',
                5: 'Mai',
                6: 'Juni',
                7: 'Juli',
                8: 'August',
                9: 'September',
                10: 'Oktober',
                11: 'November',
                12: 'Dezember'
            };
        },
        getYears() {
            let years = [],
                year = new Date().getFullYear();
            for (let i = 0; i < 50; i++) {
                years.push(year);
                year--;
            }
            return years;
        }
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R022'),
            help: this.$helpers.uiText('R023'),
            removeText: this.$helpers.uiText('R096')
        });
    },
    props: {
        moduleId: String,
        listitemId: String
    },
    components: {
        'app-text': Text,
        'app-wysiwyg': Wysiwyg,
        'app-filepicker': Filepicker,
        'app-link': Link
    }
};
</script>
